import * as React from "react";
import { navFor } from "../dashboard/select";
import useDashboardCtx from "../dashboard/useDashboardCtx";
import { useUnsignedCount } from "../hooks";
import { Badge } from "../themeV2";
import { ADMIN_SECTIONS, getIconComponent } from "./config";
import { SECTION_META } from "./sections";

const iconOf = (iconName) => {
  const Icon = getIconComponent(iconName);
  const isThemeV2Icon = Icon && !Icon.muiName;

  return Icon
    ? React.createElement(Icon, isThemeV2Icon ? {} : { fontSize: "small" })
    : null;
};

const metaOf = (section) =>
  SECTION_META[section] ?? { label: section, order: 99, collapsible: false };

/**
 * @param {"dashboard" | "mobile" | "account-menu" | "account-sidebar"} context
 */
export default function useNavigationLinks(context) {
  const ctx = useDashboardCtx();
  const { unsignedCount, unsignedCountRef } = useUnsignedCount(
    ctx.activeInfluencer?.route,
  );

  const sections = React.useMemo(() => {
    const endIconOf = ({ badge }) =>
      badge === "unsignedCount" && unsignedCount > 0
        ? React.createElement(Badge, {
            count: unsignedCount,
            variant: "count",
            ref: unsignedCountRef,
          })
        : undefined;

    return navFor(context, ctx).map(({ section, links }) => ({
      id: section,
      label: metaOf(section).label,
      order: metaOf(section).order,
      collapsible: metaOf(section).collapsible,
      links: links.map((link) => ({
        ...link,
        icon: iconOf(link.iconName),
        endIcon: endIconOf(link),
      })),
    }));
  }, [context, ctx, unsignedCount, unsignedCountRef]);

  const hasAdminLinks = React.useMemo(
    () => sections.some(({ id }) => ADMIN_SECTIONS.includes(id)),
    [sections],
  );

  return { sections, hasAdminLinks };
}
